import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, config, Observable } from 'rxjs';
import { ConfigClienteModel } from '../../models/config-cliente/config-cliente.model';
import { ConfigService } from '../config.service';

@Injectable({
  providedIn: 'root'
})
export class ConfigClienteService {

  public urlApi = this.configService.config.servidor.api_cart;

  constructor(
    private configService: ConfigService,
    private http: HttpClient
  ) { }


  public getConfigCliente(id_cliente) {
    const url = `${this.urlApi}/config_cliente/${id_cliente}`;
    return this.http.get<any>(url);
  }

  public guardarConfig(configCliente){
    const url = `${this.urlApi}/config_cliente`;
    return this.http.post<any>(url, configCliente, {observe: 'response'});
  }

  public actualizarConfig(configCliente){
    const url = `${this.urlApi}/config_cliente/${configCliente.id_cliente}`;
    return this.http.put<any>(url, configCliente, {observe: 'response'});
  }
  
}
